import { render, staticRenderFns } from "./merchant-account-contact.vue?vue&type=template&id=401c9f85&scoped=true&lang=pug"
import script from "./merchant-account-contact.vue?vue&type=script&lang=ts"
export * from "./merchant-account-contact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c9f85",
  null
  
)

export default component.exports